import { useOrg } from '../org'
import { useT } from '../i18n'

/** Выбор активной организации — в «Настройки → Организация». */
export function OrgSetting() {
  const t = useT()
  const { orgs, activeOrg, switchOrg, isLoading } = useOrg()

  if (isLoading || orgs.length === 0) {
    return <p className="text-sm text-mist">{isLoading ? t('org.loading') : t('org.none')}</p>
  }

  return (
    <div className="max-w-md">
      <label className="eyebrow mb-2" htmlFor="cabinet-org">
        {t('org.label')}
      </label>
      <select
        id="cabinet-org"
        value={activeOrg?.org_id ?? ''}
        onChange={e => {
          const id = Number(e.target.value)
          if (id && id !== activeOrg?.org_id) void switchOrg(id)
        }}
        className="w-full rounded-lg border border-hull bg-trench px-2.5 py-2 text-sm text-foam focus:border-sonar focus:outline-none"
      >
        {orgs.map(o => (
          <option key={o.org_id} value={o.org_id}>
            {o.name}
          </option>
        ))}
      </select>
    </div>
  )
}
